import { render } from "./AddEditTransaction.vue?vue&type=template&id=2289063c"
import script from "./AddEditTransaction.vue?vue&type=script&lang=js"
export * from "./AddEditTransaction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__